import { render, staticRenderFns } from "./contactar.vue?vue&type=template&id=565840a6&scoped=true"
import script from "./contactar.vue?vue&type=script&lang=js"
export * from "./contactar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565840a6",
  null
  
)

export default component.exports